import axios from "axios";
import Swal from "sweetalert2";

import Constants from "./constants";
import {Auth} from "../services";
import Globals from "./globals";

// Environment
import ENV from "./env";

let _axios = axios.create({
  baseURL: ENV.BaseURI,
});

// Bandera global para evitar múltiples alertas si hay peticiones paralelas
let isHandled401 = false;

_axios.interceptors.request.use((request) => {
  const token = localStorage.getItem("token");

  if (token) {
    // Limpia las comillas accidentales antes de enviar el token
    const cleanToken = token.replace(/^"|"$/g, "");
    request.headers.common["Authorization"] = `Bearer ${cleanToken}`;
  }

  return request;
});

_axios.interceptors.response.use(
  (response) => {
    // Cierra el cargador (HoldOn) inmediatamente si la petición fue exitosa
    Globals.quitLoading();
    return response;
  },
  (error) => {
    // Cierra el cargador (HoldOn) ante cualquier fallo para descolgar la pantalla
    Globals.quitLoading();

    const {config, response} = error;

    // Si no hay respuesta (ej. servidor caído o error de red)
    if (!response) {
      return Promise.reject(error);
    }

    const {status, data} = response;

    // 1. CAPTURA DE USUARIO INACTIVO O NO AUTORIZADO (401)
    if (status === 401 || status === Constants.STATUS_RESPONSE_UNAUTHORIZED) {
      if (data?.message === "Token has expired") {
        return Auth.refresh(({token}) => {
          config.headers.common["Authorization"] = "Bearer " + token;
          return axios(config);
        });
      }

      // Desactiva los modales genéricos en Globals
      window._sessionExpired = true;
      error.isHandled = true;

      if (!isHandled401) {
        isHandled401 = true;

        localStorage.clear();
        sessionStorage.clear();

        const mensajeError =
          data?.error ||
          data?.message ||
          "Lo sentimos, su usuario ha sido inhabilitado";

        Swal.fire({
          title: "Acceso denegado",
          text: mensajeError,
          icon: "error",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
        }).then(() => {
          isHandled401 = false;
          window.location.href = "#/login";
          window.location.reload();
        });
      }

      return Promise.reject(error);
    }

    // 2. TOKEN EN LISTA NEGRA
    if (
      status === Constants.STATUS_RESPONSE_SERVER &&
      data?.message === "The token has been blacklisted"
    ) {
      window._sessionExpired = true;
      error.isHandled = true;
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "#/login";
      return Promise.reject(error);
    }

    // 3. RETORNO POR DEFECTO PARA CUALQUIER OTRO ERROR (ej. 422, 500)
    return Promise.reject(error);
  },
);

function createFormData(data) {
  var formdata = new FormData();
  for (var key in data) {
    formdata.append(key, data[key]);
  }
  return formdata;
}

_axios.all = axios.all;
_axios.spread = axios.spread;

_axios.upload = (url, data) => {
  return _axios.post(url, createFormData(data), {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const createFormDataAlternative = (data) => {
  var formdata = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key])) {
      for (var _key in data[key]) {
        if (Array.isArray(data[key][_key])) {
          for (var i in data[key][_key]) {
            formdata.append(
              key + "[" + _key + "][" + i + "]",
              data[key][_key][i],
            );
          }
        } else {
          formdata.append(key + "[" + _key + "]", data[key][_key]);
        }
      }
    } else {
      formdata.append(key, data[key]);
    }
  }
  return formdata;
};

_axios.uploadAlternative = (url, data) => {
  return _axios.post(url, createFormDataAlternative(data), {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export default _axios;
